import React from 'react';
import { Text } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
const MAP = {
  'dealer-trade': 'Dealer Trade',
  'vehicle-only': 'Vehicle Sale',
  'vehicle-wholesale': 'Vehicle Wholesale',
  'vehicle-with-locator': 'RecovR Sale'
};
export default function Type(props) {
  const {
    value,
    defaultValue = '---'
  } = props;
  let v;
  if (typeof value !== 'string' || !value) {
    v = defaultValue;
  } else {
    v = MAP[value] || value;
  }
  return /*#__PURE__*/_jsx(Text, {
    variant: "columnValue",
    children: v
  });
}